import { Backdrop, CircularProgress } from "@mui/material";
import React, { useContext, useEffect, useMemo, useState } from "react";
import { AppContext } from "./AppContext";
import OpeningCreateDialog from "./pages/POSEntry/OpeningCreateDialog";
import { useSearchPOSOpening } from "./shared/hooks/usePOSData";
import { useGetLoggedUser } from "./shared/hooks/useUser";

const AppInitializer = ({ children }) => {
    const { globalState, setGlobalState } = useContext(AppContext);

    const { data: userInfo } = useGetLoggedUser(true);

    const { data: todayOpen, refetch: refetchTodayOpen } =
        useSearchPOSOpening();

    const [openingBalanceDialogOpen, setOpeningBalanceDialogOpen] =
        useState(false);

    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // refetchTodayOpen();
    }, []);

    useMemo(() => {
        if (todayOpen) {
            setLoading(false);
        }
        if (todayOpen && todayOpen.length === 0) {
            setOpeningBalanceDialogOpen(true);
            setLoading(true);
        }
    }, [todayOpen]);

    const getLoggedInUser = () => {
        if (userInfo) return userInfo.name;
        else return "";
    };

    useEffect(() => {
        if (!globalState.loggedInUser) {
            setGlobalState({
                ...globalState,
                loggedInUser: getLoggedInUser(),
            });
        }
    }, []);

    return (
        <>
            {loading || !userInfo ? (
                <Backdrop
                    sx={{
                        color: "#fff",
                        zIndex: (theme) => theme.zIndex.drawer + 1,
                        position: "absolute",
                        backgroundColor: "rgba(33, 43, 54, 0.75)",
                    }}
                    open={true}
                >
                    <CircularProgress />
                    <OpeningCreateDialog
                        dialogOpen={openingBalanceDialogOpen}
                        onConfirm={() => {
                            setOpeningBalanceDialogOpen(false);
                        }}
                    ></OpeningCreateDialog>
                </Backdrop>
            ) : (
                <>{children}</>
            )}
        </>
    );
};

export default AppInitializer;
